import { WorkPrintView } from '@diana/core';
import { useParams } from 'react-router-dom';

export const WorkPrintPage = () => {
  const { workId, printContext } = useParams<{ workId: string; printContext: string }>();
  if (!workId || !printContext) return <></>;
  return <WorkPrintView workId={workId} forPrint={printContext} />;
};
